<template>
  <md-field
    v-bind="{ mdClearable: $attrs.mdClearable, class: $attrs.class }"
    :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
  >
    <label>{{ label }}</label>
    <md-select ref="select" v-bind:value="value" v-on:input="$listeners['input']" v-bind="$attrs">
      <toggle-all-option-component
        v-if="Array.isArray(value)"
        :value="value"
        :types="types"
        @toggleAll="toggleAll"
      ></toggle-all-option-component>
      <md-option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</md-option>
    </md-select>
    <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
  </md-field>
</template>

<script>
import Api from '@/openapi/src/api/ChannelsApi.js'
import SelectMixins from './SelectMixins'
import ToggleAllOptionComponent from './ToggleAllOptionComponent.vue'

export default {
  name: 'ChannelSelect',
  components: { ToggleAllOptionComponent },
  mixins: [SelectMixins],
  props: {
    value: {
      type: [Number, Array],
    },
    label: {
      type: String,
      default: 'Channel',
    },
    online: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    storeName() {
      if (this.online === null) return this.$options.name

      return `${this.$options.name}.${this.online ? 'Online' : 'Offline'}`
    },
  },
  methods: {
    loadTypes() {
      // this components is using diferent endpoint according to online attribute
      if (!this.$store.getters.get(this.storeName)) {
        var bindedFunction
        var api = new Api()

        if (this.online === null) bindedFunction = api.getChannels.bind(api, this.$root.hotelId)
        else bindedFunction = api.getChannelsOnline.bind(api, this.$root.hotelId, this.online)

        this.$store.dispatch('fetch', {
          name: this.storeName,
          function: bindedFunction,
        })
      }
    },
  },
  watch: {
    online() {
      this.loadTypes()
    },
  },
  created() {
    this.loadTypes()
  },
}
</script>
